( function() {
	function isMobile() {
		if ( navigator.userAgent.match(/^(?=.*Android)(?=.*Mobile).*/) || navigator.userAgent.match(/.*iphone.*/i) ) {
			return true;
		}
		return false;
	}

	function changeLink() {
		let buttons = document.getElementsByClassName( 'button' );

		for ( let i = 0; i < buttons.length; i++ ) {
			let button = buttons[i];
			let href = button.getAttribute( 'href' );
			if ( ! href.indexOf( '/jobs' ) < 0 ) {
				continue;
			}

			button.setAttribute( 'href', 'https://jobs.jobvite.com/sermo' );
			button.setAttribute( 'target', '_blank' );
		}
	}

	if ( isMobile() ) {
		changeLink();
	}
} )();
